import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSave?: () => void;
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, onSave, className }) => {
  if (!isOpen) return null;

  const handleSave = async () => {
    if (onSave) {
      await onSave();
    }
  };

  const modalContentClass = className || 'edit-data-modal';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content ${modalContentClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {children}
        </div>

        {onSave && (
          <div className="modal-footer">
            <button className="btn btn-primary modal-save-btn" onClick={handleSave}>
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};


